import type { TimePickerValue } from './types'

export const formatDisplayTime = (value: TimePickerValue): string => {
  const formatTime = (t?: null | string) => t || '--:--'

  switch (value.type) {
    case '24':
    case 'between':
      return `${formatTime(value.from)} - ${formatTime(value.to)}`
    case 'asap':
      return 'ASAP'
    case 'at':
      return `At ${formatTime(value.from)}`
    case 'by':
      return `Before ${formatTime(value.to)}`
    case 'tbc':
      return 'TBC'
  }
}
